import { render } from "./updateExchange.vue?vue&type=template&id=7698e62b"
import script from "./updateExchange.vue?vue&type=script&lang=js"
export * from "./updateExchange.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__